export default {
    methods: {
        filterASCII(str) {
            // $piece = preg_replace('/[^\x20-\x7E]/', '', $piece);
            // $piece = preg_replace('/(\s)+|(&nbsp;)+/im', ' ', $piece);
            str = str.replace(/[^\x20-\x7E]/ig, '');
            str = str.replace(/(\s){2,}|(&nbsp;)+/ig, ' ');
            return str;
        }
    }
};
